import { Controller } from "@hotwired/stimulus"
import * as bootstrap from "bootstrap"

export default class extends Controller {
  connect() {
    this.modal = bootstrap.Modal.getOrCreateInstance(this.element)
    this.modal.show()

    this.element.addEventListener("hidden.bs.modal", () => {
      const frame = this.element.closest("turbo-frame")
      if (frame) frame.innerHTML = ""
    })
  }

  close() {
    this.modal?.hide()
  }

  beforeCache() {
    this.modal?.hide()
  }

  disconnect() {
    if (this.modal) {
      this.modal.hide()
      this.modal.dispose()
    }
  }

}
